var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Datepicker',{attrs:{"value":_vm.value,"disabled-dates":_vm.disableDates},on:{"selected":function (date) { return _vm.$emit('selected', date); }}})}
var staticRenderFns = []

export { render, staticRenderFns }